module.exports = __webpack_public_path__ + "static/lake_erosion_left-36cd90d2c1cdd20e489ed437147f5a42.jpg";